import { 
  SET_BARCODE_INPUT, 
  SET_PASS_SCAN,
  SET_CURRENT_ORDER, 
  SET_SCAN_ERROR, 
  SET_SCAN_SUCCESS,
  SET_MAIN_INPUT_FOCUS,
  SET_PROMPT,
  SET_SERIAL_RECORD_ONE_INPUT,
  SET_SERIAL_RECORD_TWO_INPUT,
  SET_CART_SCAN_COMPLETE,
  SET_ACTIVE_CART,
  SET_IS_EMPTY_CART,
  SET_PLACED_CONFIRMATION,
  SET_ACTIVE_TOTE,
  SET_FOCUSED_ORDER,
  CLEAR_FOCUSED_ORDER,
  SET_LAST_CART_INPUT,
  SET_SCAN_TO_CART_LOADING,
  SET_CART_TYPE_SCAN_STATE
} from "../constants";

const initialState = {
  currentOrder: null,
  barcodeValue: '',
  isPassScan: false,
  scanSuccess: false,
  scanError: false,
  mainInputHasFocus: true,
  prompt: {
    isVisible: false,
    message: '',
    type: ''
  },
  scanLogs: [],
  serialRecordInputOne: '',
  serialRecordInputTwo: '',
  cartScanComplete: false,
  isNotEmptyCart: false,
  placedItemConfirmation: false,
  activeTote: null,
  focusedOrderId: null,
  lastCartInput: null,
  isLoading: false,
  typeScanState: '',
  typeScanAdjacentScans: 0,
};

export default function scanToCartScanningReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_ORDER:
      return {
        ...state,
        currentOrder: action.payload
      };
    case SET_BARCODE_INPUT:
      return {
        ...state,
        barcodeValue: action.payload
      };
    case SET_PASS_SCAN:
      return {
        ...state,
        isPassScan: action.payload
      };
    case SET_SCAN_SUCCESS:
      return {
        ...state,
        scanSuccess: action.payload
      };
    case SET_SCAN_ERROR:
      return {
        ...state,
        scanError: action.payload
      };
    case SET_MAIN_INPUT_FOCUS:
      return {
        ...state,
        mainInputHasFocus: action.payload,
      };
    case SET_CART_TYPE_SCAN_STATE:
      return {
        ...state,
        typeScanState: action.payload.typeScanState,
        typeScanAdjacentScans: action.payload.typeScanAdjacentScans
      };
    case SET_PROMPT:
      return {
        ...state,
        prompt: action.payload,
      };
    case SET_SERIAL_RECORD_ONE_INPUT:
      return {
        ...state,
        serialRecordInputOne: action.payload,
      }
    case SET_SERIAL_RECORD_TWO_INPUT:
      return {
        ...state,
        serialRecordInputTwo: action.payload,
      };
    case SET_CART_SCAN_COMPLETE:
      return {
        ...state,
        cartScanComplete: action.payload,
        focusedOrderId: action.payload ? null : state.focusedOrderId,
      };
    case SET_ACTIVE_CART:
      return action.payload?.isPicked && state.focusedOrderId != null
        ? {...state, focusedOrderId: null}
        : state;
    case SET_IS_EMPTY_CART:
      return {
        ...state,
        isNotEmptyCart: action.payload,
      };
    case SET_PLACED_CONFIRMATION:
      return {
        ...state,
        placedItemConfirmation: action.payload,
      };
    case SET_ACTIVE_TOTE:
      return {
        ...state,
        activeTote: action.payload,
      };
    case SET_FOCUSED_ORDER:
      return {
        ...state,
        focusedOrderId: action.payload,
      };
    case CLEAR_FOCUSED_ORDER:
      return {
        ...state,
        focusedOrderId: null,
      };
    case SET_LAST_CART_INPUT:
      return {
        ...state,
        lastCartInput: action.payload,
      };
    case SET_SCAN_TO_CART_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
}
